import {converge, init, tail, zip} from 'ramda'

export const createEdgesFromPoints = converge(zip, [init, tail])